import { render, staticRenderFns } from "./takecode.vue?vue&type=template&id=63933564"
import script from "./takecode.vue?vue&type=script&lang=js"
export * from "./takecode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports